import React, { PureComponent } from 'react'
import styled from 'styled-components'
import cloneDeep from 'lodash/cloneDeep'

import { tags as tagsApi } from 'gipsy-api'
import { Tag, AddTagButton } from 'gipsy-ui'
import { styles, translations, utils } from 'gipsy-misc'

import { Header, SectionContainer } from 'pages/settings/components/common'

class Tags extends PureComponent {
  state = {
    tags: [],
    mode: 'normal'
  }

  componentDidMount = () => {
    this.getTags()
  }

  getTags = async () => {
    try {
      const tags = await tagsApi.get()
      this.setState({ tags: tags })
    } catch (err) {
      this.props.handleAPIError(err)
    }
  }

  createMode = () => {
    this.setState({
      mode: 'create'
    })
  }

  onCreate = async tag => {
    try {
      const newTag = await tagsApi.create(tag)

      let tags = cloneDeep(this.state.tags) || []
      tags.push(newTag)
      this.setState({ mode: 'normal', tags: tags })
    } catch (err) {
      this.props.handleAPIError(err)
    }
  }

  editTag = async tag => {
    try {
      const newTag = await tagsApi.edit(tag)
      let tags = cloneDeep(this.state.tags)
      for (let i = 0, l = tags.length; i < l; i++) {
        if (tags[i].id === newTag.id) {
          tags.splice(i, 1, newTag)
          break
        }
      }
      this.setState({ mode: 'normal', tags: tags })
    } catch (err) {
      this.props.handleAPIError(err)
    }
  }

  onCancelCreate = () => {
    this.setState({
      mode: 'normal'
    })
  }

  onDelete = async tag => {
    try {
      await tagsApi.del(tag.id)
      let tags = cloneDeep(this.state.tags)
      for (let i = 0, l = tags.length; i < l; i++) {
        if (tags[i].id === tag.id) {
          tags.splice(i, 1)
          break
        }
      }
      this.setState({ mode: 'normal', tags: tags })
    } catch (err) {
      this.props.handleAPIError(err)
    }
  }

  choseTagColor = () => {
    const { tags } = this.state

    const tagColor = styles.colors.tagColors.find(
      tagColor => !tags || utils.array.getObjectIndexInArray(tags, tagColor, ['color']) === -1
    )

    return tagColor || utils.array.pickRandomInArray(styles.colors.tagColors)
  }

  render() {
    const { tags, mode } = this.state
    const newTagColor = this.choseTagColor()
    return (
      <SectionContainer>
        <Header title={translations.settings.section.tags.title} />
        <Subtitle>
          <span>{translations.settings.section.tags.subtitle.part1}</span>
          <span>
            <b>{translations.settings.section.tags.subtitle.part2}</b>
          </span>
          <span>{translations.settings.section.tags.subtitle.part3}</span>
        </Subtitle>
        <TagsListContainer>
          {tags &&
            tags.map(tag => (
              <Tag
                key={tag.id}
                id={tag.id}
                color={tag.color}
                backgroundColor={tag.backgroundColor}
                name={tag.name}
                mode="more"
                style={{ margin: '0px 5px 5px 0px' }}
                onDelete={this.onDelete}
                onSave={this.editTag}
              />
            ))}
          {mode === 'normal' && <AddTagButton onClick={this.createMode} />}
          {mode === 'create' && (
            <Tag
              color={newTagColor.color}
              backgroundColor={newTagColor.backgroundColor}
              mode="create"
              name=""
              onCreate={this.onCreate}
              onRemove={this.onCancelCreate}
              autofocus={true}
            />
          )}
        </TagsListContainer>
      </SectionContainer>
    )
  }
}

export default Tags

const TagsListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const Subtitle = styled.div`
  margin-bottom: 15px;
`



// WEBPACK FOOTER //
// ./src/pages/settings/components/tags/index.js